
import {Component, Vue, Watch} from 'vue-property-decorator';
import {
  readAdminExternalData,
  readAdminExternalDataList,
  readAdminForms,
  readAdminSearchEngine,
  readAdminSearchEngines,
} from '@/store/admin/getters';
import {dispatchGetForms, dispatchGetSearchEngine} from '@/store/main/actions';
import {rules} from '@/utils';
import {
  dispatchCreateSearchEngine,
  dispatchGetExternalDataListAdmin,
  dispatchUpdateSearchEngine,
} from '@/store/admin/actions';
import {ISearchEngine, SearchEngineReferences} from '@/interfaces/search_engine';
import {readForm, readQueryBuilder, readSearchEngine} from '@/store/main/getters';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import QueryBuilder from '@/components/extras/QueryBuilder.vue';
import {
  EnumReturnMode,
  EnumQueryBuilderType,
  EnumQueryOperators,
  IQueryBuilder,
} from '@/interfaces/query-builder';

@Component({
  components: {QueryBuilder, DefaultHelp},
})
export default class CRUDSearchEngine extends Vue {
  private valid: boolean = false;
  private rules: any = rules;
  private referenceForm: any = null;
  private searchEngineID: number = -1;
  private SETitle: string = `${this.$t('crud.create')} ${this.$t('form_search_engine')}`;
  private selectedOption: any = SearchEngineReferences;
  private queryBuilderUpdated: any = null;

  private currentFormID: number = 0;

  private refExternalData: any = null;
  private labelExternalDataItem: any = null;
  private refExternalDataItem: any = null;
  private externalDataHeaders: any = null;

  private enumSE: any = SearchEngineReferences;
  private enumOp: any = EnumQueryOperators;
  private searchEngine = {} as ISearchEngine;


  private selectedItemOtherForm: any = null;

  @Watch('refExternalDataItem')
  public refExternalDataItemWatch(val) {
    if (!this.labelExternalDataItem) {
      this.labelExternalDataItem = val;
    }
  }

  public async mounted() {
    await this.loadMountedSettings();
  }

  public beforeRouteLeave(to, from, next) {
    this.SETitle = `${this.$t('crud.create')} ${this.$t('form_search_engine')}`;
    this.loadMountedSettings();
    next();
  }

  private async loadMountedSettings() {
    this.searchEngineID = this.$router.currentRoute.params.id as unknown as number;
    if (!this.forms) {
      await dispatchGetForms(this.$store);
    }
    if (this.externalData.length === 0) {
      await dispatchGetExternalDataListAdmin(this.$store);
    }
    let seObj = {} as ISearchEngine;
    if (this.searchEngineID > 0) {
      this.SETitle = `${this.$t('crud.update')} ${this.$t('form_search_engine')}`;
      if (readAdminSearchEngines(this.$store).length === 0) {
        await dispatchGetSearchEngine(this.$store, this.searchEngineID);
        seObj = await readSearchEngine(this.$store) as unknown as ISearchEngine;
      } else {
        seObj = await readAdminSearchEngine(this.$store)(+this.searchEngineID) as unknown as ISearchEngine;
      }

      this.searchEngine = seObj;
      this.selectedOption = seObj.reference_type;
      this.queryBuilderUpdated = seObj.query_builder;
      this.referenceForm = await readForm(this.$store)(+seObj.form_id);
      await this.changeCurrentFormID(this.referenceForm);

      if (this.selectedOption === this.enumSE.EXTERNAL_DATA) {
        this.refExternalData = readAdminExternalData(this.$store)(+seObj.reference_key);
        this.loadDataItems();
        // @ts-ignore
        const {label, name} = seObj?.query_builder?.children[0]?.query?.operand;
        this.refExternalDataItem = name;
        this.labelExternalDataItem = label;
      } else if (this.selectedOption === this.enumSE.OTHER_FORM) {
        this.selectedItemOtherForm = await readForm(this.$store)(+seObj.reference_key);
        await this.changeCurrentFormID(this.selectedItemOtherForm);
      }
    }
  }

  private async changeCurrentFormID(item) {
    this.currentFormID = item?.id;
  }


  private async save() {
    const form: any = this.$refs.form_cse;
    if (await form.validate()) {
      if (this.selectedOption === this.enumSE.EXTERNAL_DATA) {
        const queryBuilder = {
          return_mode: EnumReturnMode.RM_ANY,
          type: EnumQueryBuilderType.SEARCH_ENGINE,
          children: [
            {
              logical_operator: null,
              query: {
                query_value: null,
                operator: EnumQueryOperators.OP_EQUAL,
                operand: {
                  name: this.refExternalDataItem,
                  label: this.labelExternalDataItem,
                },
              },
            },
          ],
        } as IQueryBuilder;
        this.searchEngine.reference_key = this.refExternalData.id;
        this.searchEngine.query_builder = queryBuilder;
      } else {
        this.searchEngine.query_builder = readQueryBuilder(this.$store) as unknown as IQueryBuilder;
        this.searchEngine.reference_key = this.referenceForm.id;
        if (this.selectedOption === this.enumSE.OTHER_FORM) {
          this.searchEngine.reference_key = this.selectedItemOtherForm.id;
        }
      }
      this.searchEngine.reference_type = this.selectedOption;
      this.searchEngine.form_id = this.referenceForm.id;

      if (this.searchEngineID > 0) {
        this.searchEngine.id = this.searchEngineID;
        if (await dispatchUpdateSearchEngine(this.$store, this.searchEngine)) {
          await dispatchGetForms(this.$store);
          this.$router.push({name: 'main-admin-search-engine-list'});
        }
      } else {
        if (await dispatchCreateSearchEngine(this.$store, this.searchEngine)) {
          this.$router.push({name: 'main-admin-search-engine-list'});
        }
      }
    }
  }

  private cancel() {
    this.$router.back();
  }

  private reset() {
    // @ts-ignore
    this.$refs.form_cse.reset();
  }

  private get forms() {
    return readAdminForms(this.$store);
  }

  private get formsOther() {
    if (this.referenceForm) {
      const resp = [...this.forms];
      return resp.filter((e) => e.id !== this.referenceForm.id);
    }
    return [];
  }

  private get dataSource() {
    return SearchEngineReferences;
  }

  private get externalData() {
    return readAdminExternalDataList(this.$store);
  }

  private loadDataItems() {
    this.currentFormID = 0;
    if (this.refExternalData) {
      this.externalDataHeaders = this.refExternalData.headers;
    }
  }

}
